import {
  Identifiable,
  Planzone,
  ProjectListingConfiguration,
} from "@planzone/dto";
import { HttpClient, HttpMethods } from "@planzone/services";

function updateProjectListingConfiguration(httpClient: HttpClient) {
  return (
    { uuid }: Identifiable<Planzone>,
    configuration: ProjectListingConfiguration,
    nextConfiguration: ProjectListingConfiguration,
  ) =>
    httpClient.sendHttpRequest<void>({
      endpoint: `/planzones/${uuid}`,
      method: HttpMethods.PATCH,
      data: {
        data: {
          projectsListingViewConfigurations: JSON.stringify(nextConfiguration),
        },
      },
    });
}

export { updateProjectListingConfiguration };
